export default "/_next/static/media/zion-1-pf-basketball-shoe-bHGvxg.8b51637e85db2e7d1e09f3d11efaa8d9.jpeg";